/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/PoolRegistry.json';
import { PoolRegistry } from 'libs/contracts/generated/infos/contractTypes';
import { getUniqueContractAddress } from 'libs/contracts/utilities/getUniqueContractAddress';
import { useChainId, useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetPoolRegistryContractAddressInput {
  chainId: ChainId;
}

export const getPoolRegistryContractAddress = ({ chainId }: GetPoolRegistryContractAddressInput) =>
  getUniqueContractAddress({ name: 'PoolRegistry', chainId });

export const useGetPoolRegistryContractAddress = () => {
  const { chainId } = useChainId();

  return useMemo(
    () =>
      getPoolRegistryContractAddress({
        chainId,
      }),
    [chainId],
  );
};

interface GetPoolRegistryContractInput {
  chainId: ChainId;
  signerOrProvider: Signer | Provider;
}

export const getPoolRegistryContract = ({
  chainId,
  signerOrProvider,
}: GetPoolRegistryContractInput) => {
  const address = getPoolRegistryContractAddress({ chainId });
  return address ? (new Contract(address, abi, signerOrProvider) as PoolRegistry) : undefined;
};

interface UseGetPoolRegistryContractInput {
  passSigner?: boolean;
  chainId?: ChainId;
}

export const useGetPoolRegistryContract = (input?: UseGetPoolRegistryContractInput) => {
  const { chainId: currentChainId } = useChainId();
  const chainId = input?.chainId || currentChainId;

  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = input?.passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getPoolRegistryContract({
            chainId,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, chainId],
  );
};
